module.exports = __webpack_public_path__ + "1605ed509408d3e79d7c5ca5701634d3.MP3";